import http from "../http-common";

class MaterialColorDataService {
  getByMaterialBrand(brandid) {
    return http.get(`/materialcolors/search/?brandId=${brandid}`);
  }

  getMaterialColorByDescr(condition, sortfield,sorttype) {
    return http.get(`/materialcolors/search/?materialcolorname=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  get(id) {
    return http.get(`/materialcolors/${id}`);
  }

  create(data) {
    return http.post("/materialcolors/newmaterialcolor", data);
  }

  update(id, data) {
    return http.put(`/materialcolors/${id}`, data);
  }

  delete(id) {
    return http.delete(`/materialcolors/${id}`);
  }

  deleteAll() {
    return http.delete(`/materialcolors`);
  }

  findById(id) {
    return http.get(`/materialcolors?id=${id}`);
  }
}

export default new MaterialColorDataService();